import { render, staticRenderFns } from "./tabMBL2UICustom.vue?vue&type=template&id=92e270c2&scoped=true&"
import script from "./tabMBL2UICustom.vue?vue&type=script&lang=js&"
export * from "./tabMBL2UICustom.vue?vue&type=script&lang=js&"
import style0 from "./tabMBL2UICustom.vue?vue&type=style&index=0&id=92e270c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92e270c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92e270c2')) {
      api.createRecord('92e270c2', component.options)
    } else {
      api.reload('92e270c2', component.options)
    }
    module.hot.accept("./tabMBL2UICustom.vue?vue&type=template&id=92e270c2&scoped=true&", function () {
      api.rerender('92e270c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/tabMBL2UICustom.vue"
export default component.exports